import { useEffect, useState } from "react";
import { LANDING_URL } from "../../env";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import KorresLogo from "../../components/Common/KorresLogo";
import { fetchAndCacheTerms, getCachedTerms } from "../../api/postgre/termsApi";

const parseTermsLines = (text) =>
    text
        .split("\n")
        .map((line) => line.trim())
        .filter(Boolean);


const TermsAndConditions = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const canGoBack = window.history.length > 1;
    const language = i18n.language || "en";

    const [termsLines, setTermsLines] = useState(() => {
        const cached = getCachedTerms(language);
        return cached ? parseTermsLines(cached) : null;
    });

    useEffect(() => {
        window.history.scrollRestoration = "manual";
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        fetchAndCacheTerms(language)
            .then((result) => {
                if (result.terms) {
                    setTermsLines(parseTermsLines(result.terms));
                }
            })
            .catch((err) => {
                console.error("Failed to load terms:", err);
            });
    }, [language]);

    const lines = termsLines || [];

    return (
        <div className="min-h-screen bg-white px-6 py-12 sm:px-10 lg:px-20">
            <div className="mx-auto max-w-3xl">
                <div className="mb-8 flex items-center justify-between">
                    <a href={LANDING_URL} className="hover:opacity-75 transition-opacity">
                        <KorresLogo />
                    </a>
                    {canGoBack && (
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="text-sm text-slate-500 hover:text-primary hover:underline underline-offset-4"
                        >
                            ← {t("COMMON_BACK")}
                        </button>
                    )}
                </div>

                <div className="space-y-3 text-sm text-slate-700">
                    {lines.map((line, index) => {
                        const urlMatch = line.match(/(https?:\/\/[^\s),]+)/);
                        const renderWithLink = (text, className) => {
                            if (!urlMatch) return text;
                            const url = urlMatch[1];
                            const parts = text.split(url);
                            return (
                                <>
                                    {parts[0]}
                                    <a
                                        href={url}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-primary underline underline-offset-4"
                                    >
                                        {url}
                                    </a>
                                    {parts[1]}
                                </>
                            );
                        };

                        if (index === 0) {
                            return (
                                <h1 key={index} className="text-lg font-bold text-slate-900">
                                    {renderWithLink(line)}
                                </h1>
                            );
                        }
                        return <p key={index}>{renderWithLink(line)}</p>;
                    })}
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
